'use client'

import Alert from '@dd3tech/wiggui/Alert'
import Button from '@dd3tech/wiggui/Button'
import Checkbox from '@dd3tech/wiggui/Checkbox'
import Modal from '@dd3tech/wiggui/Modal'
import Text from '@dd3tech/wiggui/Text'
import { useModalDownloadPropertiesXlsx } from './hooks/useModalDownloadPropertiesXlsx'
import { useModalDownloadPropertiesXlsxStore } from '../../store'
import { MdOutlineFileDownload } from 'react-icons/md'

export const ModalDownloadPropertiesXlsx = () => {
  const {
    handleGetGeneratedPropertiesXlsx,
    onClose,
    isLoading,
    selectedStatuses,
    handleStatusChange
  } = useModalDownloadPropertiesXlsx()
  const isOpen = useModalDownloadPropertiesXlsxStore(
    (state) => state.modalDownloadPropertiesXlsx.isOpen
  )

  return (
    <Modal
      enableBgBlur
      className="max-w-[524px]"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Header
        title="Exportar propiedades"
        isShowCloseButton
        isShowDivider
      />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-start justify-center">
        <Text className="text-secondary text-body-m w-full" align="left">
          Selecciona los estados de las propiedades que deseas exportar.
        </Text>
        <div className="w-full flex gap-4">
          <Checkbox
            id="published"
            name="published"
            type="checkbox"
            label="Publicadas"
            isChecked={selectedStatuses.PUBLISHED}
            onChange={() => handleStatusChange('PUBLISHED')}
            labelClassName="text-primary text-body-bold-m"
            containerClassName="w-full items-center justify-start flex flex-row"
            inputClassName="min-w-[24px]"
          />
          <Checkbox
            id="not-published"
            name="not-published"
            type="checkbox"
            label="Archivadas"
            isChecked={selectedStatuses.NOT_PUBLISHED}
            onChange={() => handleStatusChange('NOT_PUBLISHED')}
            labelClassName="text-primary text-body-bold-m"
            containerClassName="w-full items-center justify-start flex flex-row"
            inputClassName="min-w-[24px]"
          />
        </div>
        <Alert
          padding="p-3"
          type="neutral"
          className="w-full"
          containerIconClassName="[&>span]:!text-primary items-center flex justify-start w-full !gap-3"
          containerTextClassName="[&>p]:!text-body-bold-m"
          title="El formato de descarga es compatible con Excel y otras herramientas de hojas de cálculo."
        />
      </Modal.Body>
      <Modal.Footer className="py-3 px-6 flex w-full flex-row items-center justify-center gap-3">
        <Button
          variant="terciary"
          isDisabled={isLoading}
          onClick={onClose}
          fullWidth
        >
          Cancelar
        </Button>
        <Button
          variant="secondary"
          isLoading={isLoading}
          onClick={handleGetGeneratedPropertiesXlsx}
          fullWidth
        >
          Exportar
          <MdOutlineFileDownload className="min-w-[24px] min-h-[24px]" />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
